import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=6922c8ec&scoped=true&"
import script from "./Shell.vue?vue&type=script&lang=ts&"
export * from "./Shell.vue?vue&type=script&lang=ts&"
import style0 from "./Shell.vue?vue&type=style&index=0&id=6922c8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922c8ec",
  null
  
)

export default component.exports